/* istanbul ignore file */
import { classNames } from '@panwds/tailwindcss';
import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react';
export const ShowMoreLessColumnText = forwardRef(({ moreText = 'Show More', lessText = 'Show Less', value, rowId }, ref) => {
    const internalRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    useLayoutEffect(() => {
        const { current } = internalRef;
        const parent = current?.parentNode;
        if (current) {
            const parentHeight = parent.clientHeight;
            const childHeight = current.clientHeight;
            const rowEl = current && current.closest(`#row-${rowId}`);
            if (childHeight > parentHeight) {
                setShowButton(true);
            }
            if (isExpanded) {
                if (rowEl)
                    rowEl.style.setProperty('height', 'auto');
            }
            else {
                if (rowEl)
                    rowEl.style.removeProperty('height');
            }
        }
    }, [internalRef, isExpanded, setShowButton]);
    return (React.createElement("div", { className: classNames('twds-flex twds-w-full', isExpanded ? 'twds-flex-col' : 'twds-flex-row'), ref: internalRef },
        React.createElement("div", { "data-testid": `show-more-${rowId}`, ref: ref, className: classNames(showButton && (isExpanded ? 'twds-mt-2' : 'twds-truncate')) }, value),
        showButton && (React.createElement("button", { type: "button", "data-testid": `show-more-less-button-${rowId}`, className: classNames('twds-flex-shrink-0', 'twds-ml-2 twds-mr-0 twds-mt-0 twds-mb-0 twds-border-none twds-bg-transparent twds-text-link twds-text-xs dark:twds-text-blue-400 twds-cursor-pointer hover:twds-underline', showButton && (isExpanded ? 'twds-self-end' : 'twds-self-start')), onClick: () => setIsExpanded(!isExpanded) }, isExpanded ? lessText : moreText))));
});
ShowMoreLessColumnText.displayName = 'ShowMoreLessColumnText';
//# sourceMappingURL=ShowMoreLessColumnText.js.map